import axios, { AxiosResponse } from 'axios';
import jwtDecode from 'jwt-decode';

interface JwtPayload {
  given_name: string;
  family_name: string;
}

const renderTemplate = (data: any): Promise<AxiosResponse<any>> => {
	const token = localStorage.getItem('rslt_id_token');
	if (!token) {
		return Promise.reject(new Error('No JWT token found'));
	}

	const decodedToken: JwtPayload = jwtDecode(token);

	data.extra_template_variables = {
		loggedinUser: {
			firstName: decodedToken.given_name,
			lastName: decodedToken.family_name
		}
	};

	return axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/templating/frontend-render/v2`, data, {
		headers: {
			Authorization: `Bearer ${token}`
		}
	});
};

export {
	renderTemplate
};
